/** A share as a whole percentage, at least 1% when anything is there. */
export function formatPercent(part: number, whole: number): string {
  if (!whole || !part) return '0%';
  return `${Math.max(1, Math.round((part / whole) * 100))}%`;
}
